import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sqg-form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-form__intro" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Primes :"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Ce formulaire sert au paramétrage d’une seule prime."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Le descriptif est très important afin de nous permettre un paramétrage optimal."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("N’hésitez pas à nous mettre un exemple de salarié et toujours avec un exemple détaillé du calcul."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Si votre prime est lié à une saisie manuelle, vous pouvez également le renseigner au niveau du descriptif. ")
], -1)
const _hoisted_4 = { class: "sqg-form__actionBar" }
const _hoisted_5 = { class: "sqg-form__actionBar" }
const _hoisted_6 = { class: "sqg-form__actionBar" }

import { computed, ComputedRef, defineAsyncComponent, defineComponent, onMounted, ref } from "vue";
import apiClient from "@/api/spaceMountainAPI";
import apiAdmin from "@/api/spaceMountainAdminAPI";
import { AxiosResponse } from "axios";
import { useUserStore } from "@/stores/user";
import { storeToRefs } from "pinia";
import {getForm} from "@/functions/forms";
import Modale from '@/modales/Modale.vue';
import FormTemplate from '@/forms/FormTemplate.vue';
import Loader from '@/components/Loader.vue';
import CardButton from '@/components/CardButton.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  formId: { type: String, default: '' },
  readOnly: { type: Boolean, default: false }
},
  emits: ['save'],
  setup(__props, { emit }) {

const props = __props





//STORE user
const usersStore = useUserStore();
const { user } = storeToRefs(usersStore);

//DATA
const step = ref(0);
const idTech = ref(props.formId);
const loader = ref(true);
const loaderMsg = ref('Récupération des données');

//V-MODEL
const model = ref({
  primeStep1: [
    { type: "text", required: true, placeholder: "Libellé sur le bulletin", field: "libelleBulletin", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { type: "textarea", required: false, placeholder: "Descriptif de la prime (description détaillée du calcul de la base et du taux de la prime) :", field: "descriptifPrime", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { type: "radio", required: true, placeholder: "Cette prime fera-t-elle l’objet d’un suivi particulier au niveau d’un reporting (création d’un stockvar)", field: "stockvarPrime", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
  ],
  primeStep2: [
    { type: "radio", required: true, placeholder: "Prime imposable", field: "isPrimeImposable", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { type: "radio", required: true, placeholder: "Prime soumise à cotisations : ", field: "isPrimeSoumiseACotisations", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { type: "radio", required: true, placeholder: "Prime intégrant le taux horaire pour absence : ", field: "isPrimeIntegrantTauxHoraireAbsence", choices: [ { name: "OUI", id: true }, { name: "NON", id: false }], value: false },
    { type: "radio", required: true, placeholder: "Prime intégrée dans le calcul de la provision congés payés : ", field: "isPrimeIntegreeCalculProvisionCp", choices: [ { name: "OUI", id: true }, { name: "NON", id: false }], value: false },
    { type: "radio", required: true, placeholder: "Prime intégrant le taux de majoration des heures supplémentaires :", field: "isPrimeIntegrantMajorationHeuresSup", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false, },
    { type: "radio", required: true, placeholder: "Cette prime remplace-t-elle une prime conventionnelle existante : ", field: "isPrimeRemplacePrimeConventionnelle", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { type: "text", required: false, placeholder: "Compte comptable spécifique :", field: "compteComptableSpecifique", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { type: "text", required: true, placeholder: "Population concernée par la prime :", field: "populationConcerneePrime", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
  ]
});

const formToSend: ComputedRef<Object> = computed(() => {
  let result: any = {
    primeStep1: {},
    primeStep2: {},
  };
  model.value.primeStep1.forEach((input: any) => {
    if (input.value !== '') result.primeStep1[input.field] = input.value;
  });
  model.value.primeStep2.forEach((input: any) => {
    if (input.value !== '') result.primeStep2[input.field] = input.value;
  });
  return result;
});

const api = () => {
  if (user.value.role ==='admin' || user.value.role ==='superAdmin') return apiAdmin;
  else return apiClient;
};

const saveForm = () => {
  loaderMsg.value = "Sauvegarde des données";
  loader.value = true;
  step.value = 1;
  apiClient.saveForm(idTech.value, formToSend.value).then(() => {
    loader.value = false;
    emit('save');
  });
};

const submitForm = () => {
  loaderMsg.value = "Soumission du formulaire";
  loader.value = true;
  apiClient.submitForm(idTech.value, formToSend.value).then(() => {
    loader.value = false;
    emit('save');
  });
};

onMounted(() => {
  api().getForm(idTech.value).then((response: AxiosResponse) => {
    getForm(response, model.value);
    loader.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Modale, {
      title: "Formulaire de prime",
      width: "50",
      height: "90",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        (loader.value)
          ? (_openBlock(), _createBlock(Loader, {
              key: 0,
              msg: loaderMsg.value
            }, null, 8, ["msg"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (step.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(CardButton, {
                        width: "100",
                        height: "96",
                        icon: "fas fa-arrow-right",
                        text: "Etape suivante",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value++))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (step.value === 1)
                ? (_openBlock(), _createBlock(FormTemplate, {
                    key: 1,
                    inputs: model.value.primeStep1,
                    readOnly: __props.readOnly,
                    title: "Primes - Etape 1"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (step.value--))
                        }),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: saveForm
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(CardButton, {
                          disabled: errorCount !== 0,
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-right",
                          text: "Etape suivante",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (step.value++))
                        }, null, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["inputs", "readOnly"]))
                : _createCommentVNode("", true),
              (step.value === 2)
                ? (_openBlock(), _createBlock(FormTemplate, {
                    key: 2,
                    formId: __props.formId,
                    inputs: model.value.primeStep2,
                    readOnly: __props.readOnly,
                    title: "Primes - Etape 2"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (step.value--))
                        }),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: saveForm
                            }))
                          : _createCommentVNode("", true),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 1,
                              disabled: errorCount !== 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-paper-plane",
                              text: "Soumettre",
                              onClick: submitForm
                            }, null, 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["formId", "inputs", "readOnly"]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})